import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ConfigModel } from 'src/app/config/config.model';
import { ConfigService } from 'src/app/config/config.service';
import {  ClienteService, ConsolidadoService, ModeloCuentaMS, ObtenerConsolidadoME } from 'src/app/open-api';
import { AuthService } from '../../services/auth.service';
import { UserModel } from '../../models/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { TipoCertificadoMS } from 'src/app/open-api/model/tipoCertificadoMS';
import { ObtenerListaTipoCertificadoME } from 'src/app/open-api/model/obtenerListaTipoCertificadoME';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMPTY_STRING } from 'src/app/shared/utils/regular-expresions';
import Swal from 'sweetalert2';
import { GeneraCertificadoME } from 'src/app/open-api/model/generaCertificadoME';
import { AppToastService } from '../../services/app-toast.service';

@Component({
  selector: 'app-certificados-cuenta',
  templateUrl: './certificados-cuenta.component.html',
  styleUrls: ['./certificados-cuenta.component.scss']
})
export class CertificadosCuentaComponent implements OnInit {
  @Input() set SecuencialCuenta(secuencial: number) {
    this.secuencialCuenta = secuencial;
  }
  secuencialCuenta?: number
  protected configModel?: ConfigModel;

  cuentas: ModeloCuentaMS[] = [];
  cuentaSeleccionada :ModeloCuentaMS = {}
  usuario?: UserModel;
  seleccionoCertificado=false;
  certificados:TipoCertificadoMS[]=[]
  certificadoSeleccionado:TipoCertificadoMS={}
  datosForm: FormGroup;
  errroSaldo = EMPTY_STRING;
  activarButton= false;
  
  constructor(
    private localeService: BsLocaleService,
    protected configService: ConfigService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private consolidadoService: ConsolidadoService,
    private clienteService:ClienteService,
    private fb: FormBuilder,
    private toastService: AppToastService,
  ) { 
    this.localeService.use('es');
    this.configService.config$.subscribe((configModel) => {
      this.configModel = configModel;
    });

    this.datosForm = this.fb.group({
       cuenta: ['', [Validators.required, Validators.min(0)]],
       certificado: ['', [Validators.required]],

    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.SecuencialCuenta) this.ngOnInit();
  }

  async ngOnInit(): Promise<void> {
   await this.ObtenerUsuario();
   await this.ObtenerConsolidado();
  await  this.ObtenerCertificados();
  }



 async ObtenerUsuario() {
 await this.authService.user.subscribe((usuario) => {
      this.usuario = usuario;
    });
  }

  async ObtenerCertificados(){
    const parametro:ObtenerListaTipoCertificadoME ={
      secuencialEmpresa:this.usuario?.secuencialEmpresa
    }
  await  this.clienteService.apiV10ClienteObtenerListaTipoCertificadosPost(parametro).subscribe(repuesta =>{
      this.certificados = repuesta?.tipoCertificados?.filter(item=> item.esParaCuenta) ??  [] 
    })
  }

async  ObtenerConsolidado() {
    this.spinner.show();
    const parametro: ObtenerConsolidadoME = {
      numeroCliente: this.usuario?.numeroCliente,
      secuencialEmpresa: this.usuario?.secuencialEmpresa,
    };
 await   this.consolidadoService
      .apiV10ConsolidadoObtenerPost(parametro)
      .subscribe((respuesta) => {
        this.cuentas = (respuesta.cuentas || []).filter(
          (c) => c.permiteTransaccionOperativa
        );
        this.InformacionCuentaSeleccionada();
        this.spinner.hide();
      });
  }


 async InformacionCuentaSeleccionada(){
    this.cuentaSeleccionada = await this.cuentas.find(item=> item.secuencial == this.secuencialCuenta) || {};
    if(!this.cuentaSeleccionada.codigo){
      this.toastService.show('Está cuenta no permite transacciones','bg-warning text-white');
    }
  }


  VerificarCertificado(certficado:string){
    if(certficado){
      this.seleccionoCertificado = true;
      this.certificadoSeleccionado = this.certificados.find(item=> item.secuencial == Number(certficado)) || {}
    }

  }

  validarSaldo(cuenta:string){
    const dataCuenta = this.cuentas.find(item=> item.secuencial == Number(cuenta));
    if((dataCuenta?.saldoDisponible||0) < (this.certificadoSeleccionado.valorDebito || 0)){
     
      this.errroSaldo =
      'La cuenta no tiene saldo suficiente para la transacción';
      this.activarButton = false;
      return;
    }
  this.activarButton = true;
  this.errroSaldo = EMPTY_STRING;
  }



  async GenerarCertificado() {
    const cuentaDebito = this.datosForm.get('cuenta')?.value;
    const cuentaCertificado = this.datosForm.get('certificado')?.value;
  
const result = await Swal.fire({
  title: "Confirmar acción",
  text: "Esta acción debitará el valor indicado de la cuenta seleccionada. Se emitirá un certificado sin firma digital ni sello. ¿Desea continuar?",
  showCancelButton: true,
  confirmButtonColor: "#3b7851",
  cancelButtonColor: "#d33",
  confirmButtonText: "Sí",
  cancelButtonText: "No",
  icon: "question",
  iconColor: "#3b7851"
});
  
    if (result.isConfirmed) {
      this.spinner.show();
  
      const parametro: GeneraCertificadoME = {
        secuencialCliente: this.usuario?.numeroCliente,
        secuencialCuentaDebito: cuentaDebito,
        secuencialCuentaCertificado: this.secuencialCuenta,
        secuencialTipoCertificacion:cuentaCertificado
      };
  
      try {
        await this.clienteService.apiV10ClienteGeneraCertificadoPost(parametro).toPromise();
        this.spinner.hide();
        this.toastService.show('El certificado ha sido enviando a su correo electrónico', 'bg-success text-light');
      } catch (error) {
        this.spinner.hide();
        this.toastService.show('Ha ocurrido un error al generar el certificado', 'bg-danger text-light');
      }
    }
  }
  
  }
  
